import React from 'react'

import { Modal } from '@/components/ui'

import LocationMap, { type MapLocation } from './LocationMap'

export type { MapLocation }

export interface MapModalProps {
  show: boolean
  onHide: () => void
  location: MapLocation
  title?: string
  markerContent?: React.ReactNode
}

export default function MapModal({ show, onHide, location, title = 'Location Map', markerContent }: MapModalProps) {
  return (
    <Modal
      maxWidth="70vw"
      show={show}
      onHide={onHide}
      title={title}
      bodyContent={
        <div className="w-full h-[50vh]">
          <div className="mb-4">
            <div className="text-sm text-gray-600">
              <div>{location.address !== 'N/A' && location.address}</div>
              <div>
                {location.lat}, {location.lng}
              </div>
            </div>
          </div>
          {show ? <LocationMap location={location} markerContent={markerContent} /> : null}
        </div>
      }
    />
  )
}
